module.exports = __webpack_public_path__ + "static/media/apex-s4-bg.ca9f1d4d.jpg";